
import {
  defineComponent,
  ref,
  onMounted,
  reactive,
  computed,
  onUpdated,
} from "vue";
import filiation from "@/filiation/composables/useFiliation";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { Field, ErrorMessage } from "vee-validate";
import Camera from "simple-vue-camera";
import { useRoute } from "vue-router";
export default defineComponent({
  name: "picturesData",
  components: {
    Field,
    ErrorMessage,
    Camera,
  },
  setup() {
    const route = useRoute();
    const { dataToEdit, fotosPorId } = filiation();
    const cameraFrontal = ref(false);
    const cameraDerecha = ref(false);
    const cameraIzquierda = ref(false);
    const formData: any = reactive({
      frente: "",
      derecha: "",
      izquierda: "",
    });
    const onFileChange = (e) => {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      createImage(files[0]);
    };
    const createImage = (file) => {
      formData.frente = new Image();
      var reader = new FileReader();

      reader.onload = (e) => {
        formData.frente = e.target?.result;
      };
      reader.readAsDataURL(file);
    };
    const onFileChangeDerecha = (e) => {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      createImageDerecha(files[0]);
    };
    const createImageDerecha = (file) => {
      formData.derecha = new Image();
      var reader = new FileReader();

      reader.onload = (e) => {
        formData.derecha = e.target?.result;
      };
      reader.readAsDataURL(file);
    };

    const onFileChangeIzquierda = (e) => {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      createImageIzquierda(files[0]);
    };
    const createImageIzquierda = (file) => {
      formData.izquierda = new Image();
      var reader = new FileReader();

      reader.onload = (e) => {
        formData.izquierda = e.target?.result;
      };
      reader.readAsDataURL(file);
    };
    const openCamera = () => {
      cameraFrontal.value = !cameraFrontal.value;
    };
    const openCameraDerecha = () => {
      cameraDerecha.value = !cameraDerecha.value;
    };
    const openCameraIzquierda = () => {
      cameraIzquierda.value = !cameraIzquierda.value;
    };
    const camera = ref<InstanceType<typeof Camera>>();
    const snapshot = async () => {
      const blob = await camera.value?.snapshot();
      // To show the screenshot with an image tag, create a url
      //   const url = URL.createObjectURL(blob);
      //   console.log(url);
      const res = await convertBlobToBase64(blob);
      if (formData.frente == "") {
        formData.frente = res as string;
      } else if (formData.frente != null && formData.derecha == "") {
        formData.derecha = res as string;
      } else if (formData.frente != null && formData.derecha != null) {
        formData.izquierda = res as string;
      }
    };

    const convertBlobToBase64 = async (blob) => {
      // blob data
      return await blobToBase64(blob);
    };
    const blobToBase64 = (blob) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    const deletesnapshot = () => {
      formData.frente = "";
    };
    const deletesnapshotDerecha = () => {
      formData.derecha = "";
    };
    const deletesnapshotIzquierda = () => {
      formData.izquierda = "";
    };
    const dataEdit = computed(() => dataToEdit.value);
    const personDetails = computed(() => route.params.id_persona);
    const orderDetails = computed(() => route.params.id_orden_judicial);
    const get_fotos = async (id) => {
      const { data } = await fotosPorId({
        id_persona: id,
      });
      formData.frente = data.fotos[0].frontal;
      formData.derecha = data.fotos[0].derecho;
      formData.izquierda = data.fotos[0].izquierdo;
    };
    onMounted(() => {
      setCurrentPageBreadcrumbs("Fotografías", [
        "Registro privado de libertad",
      ]);
      if (personDetails.value !== "0" && orderDetails.value !== "0") {
        get_fotos(personDetails.value);
        // const data = JSON.parse(localStorage.getItem("edit") || "{}");
        // formData.frente = data.general[0].frontal;
        // formData.derecha = data.general[0].derecho;
        // formData.izquierda = data.general[0].izquierdo;
      }
    });
    return {
      dataEdit,
      cameraFrontal,
      cameraDerecha,
      cameraIzquierda,
      formData,
      openCamera,
      openCameraDerecha,
      openCameraIzquierda,
      camera,
      snapshot,
      deletesnapshot,
      deletesnapshotDerecha,
      deletesnapshotIzquierda,
      onFileChange,
      onFileChangeDerecha,
      onFileChangeIzquierda,
      createImage,
      createImageDerecha,
      createImageIzquierda,
    };
  },
});
